import Echarts from './echarts.vue';

Echarts.install = function (Vue) {
  Vue.component(Echarts.name, Echarts);
}

export default Echarts;


// WEBPACK FOOTER //
// ./src/components/echarts/index.js